import {
  createRestApi,
  DefaultGetAllResponse,
  DefaultGetResponse,
} from './rest';
import { MessageTemplate } from '~/types/models';
import usePagination, {
  PaginationOptions,
  PaginationMetadata,
} from '~/react-hooks/usePagination';
import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { Metadata } from '../Modules/Settings/MessageTemplates/Pages/Editor/Context';

interface MessageTemplatePaginationMetadata extends PaginationMetadata {
  templateTotal: number;
}

const baseUrl = '/api/v3/message-templates';

interface GetAllMessageTemplatesResponse
  extends DefaultGetAllResponse<MessageTemplate> {
  templateTotal: number;
}

interface GetMessageTemplateResponse {
  data: MessageTemplate;
}

export default createRestApi<
  MessageTemplate,
  GetAllMessageTemplatesResponse,
  GetMessageTemplateResponse
>(baseUrl);

interface UsePaginatedMessageTemplatesProps {
  paginatorOptions: PaginationOptions;
}

export function usePaginatedMessageTemplates({
  paginatorOptions,
}: UsePaginatedMessageTemplatesProps) {
  const [templates, paginator, metadata] = usePagination<
    MessageTemplate,
    MessageTemplatePaginationMetadata
  >(baseUrl, paginatorOptions);

  return {
    templates,
    paginator,
    metadata,
  };
}

interface GetMetadataResponse {
  data: Metadata;
}

export async function getMetadata(greetId: string = '') {
  const res = await axios.get<GetMetadataResponse>(
    `/api/v3/message-templates/metadata/${greetId}`
  );
  return res.data.data;
}

export interface MetadataHookParams {
  greetId?: string;
  options?: UseQueryOptions<DefaultGetResponse<Metadata>, AxiosError>;
}

export const useMetadata = ({ greetId, options = {} }: MetadataHookParams) =>
  useQuery<DefaultGetResponse<Metadata>, AxiosError>(
    `metadata-${greetId ?? 'none'}`,
    () => getMetadata(greetId),
    options
  );
